var searchReqParam = function (params = {}) {
    return {
        meta: {
            code: "agent-tms-client",
            client: "PC",
            tag: "agent-tms-client",
            time: Date.now(),
        },
        params,
    };
};

export { searchReqParam }
